import { Route } from "react-router";

import React from "react";
import { ProtectedRoute } from "./components";
import { CompanyList, UsersList, CorporateSettings } from "@/pages";
import {
  permissionsCompaniesReadonly,
  permissionsUsersFull,
  permissionsSettings,
} from "@/utils";
import { companyRoutes } from "./companyRoutes";
import { userRoutes } from "./userRoutes";
import { locationRoutes } from "./locationRoutes";

type argsType = {
  showLocations?: boolean;
  showAddLocation?: boolean;
  showEditLocation?: boolean;
  showDeleteLocation?: boolean;
  showCompanies?: boolean;
};

export const tenantRoutes = (
  parentPath: string,
  args: argsType = {},
): React.ReactElement[] => [
  <Route
    key="tenants-settings"
    path="settings"
    element={
      <ProtectedRoute
        element={<CorporateSettings />}
        codes={permissionsSettings}
        feature="common"
      />
    }
  />,
  <Route
    key="companies"
    path="companies"
    element={
      <ProtectedRoute
        element={
          <CompanyList
            companyFilter="tenant"
            parentPath={parentPath}
            parentChildfilter="all"
          />
        }
        codes={permissionsCompaniesReadonly}
      />
    }
  />,
  <Route
    key="tenants-users"
    path="users"
    element={
      <ProtectedRoute
        element={<UsersList userFilter="tenant" parentPath={parentPath} />}
        codes={permissionsUsersFull}
      />
    }
  />,
  <Route path="companies/:customerId">{companyRoutes(parentPath, args)}</Route>,
  <Route path="users/:userId">{userRoutes(parentPath)}</Route>,
  <Route path="companies/:customerId/locations">
    {locationRoutes(parentPath, args)}
  </Route>,
];
